import { getNotificationOpenCountRoute } from "@slfinrtl/ui-bff-routes"
import type { NotificationCountView } from "@slfinrtl/ui-bff-routes"
import { useBffDynamic } from "src/hooks"

export const useNotificationOpenCount = () => {
	const fetchNotificationOpenCount = useBffDynamic(getNotificationOpenCountRoute, "none")

	return (): Promise<NotificationCountView> => {
		return fetchNotificationOpenCount({
			body: undefined,
			pathParams: {},
			queryParams: {},
		})
	}
}
